// extracted by mini-css-extract-plugin
export var buttonWrapper = "component-module--buttonWrapper--a3494";
export var content = "component-module--content--18eab";
export var contentWrapper = "component-module--contentWrapper--f89a0";
export var imgWrapper = "component-module--imgWrapper--1ff97";
export var main = "component-module--main--59179";
export var title = "component-module--title--56de2";
export var titleContentWrapper = "component-module--titleContentWrapper--27839";